@for (config of buttonsConfig; track $index; let i = $index; let last = $last) {
    <wdx-radio-button
        [label]="config.label"
        [icon]="config.icon"
        [disabled]="disabled"
        [value]="config.value"
        [checked]="value === config.value"
        [size]="size"
        [checkedStyle]="WdxButtonStyle.OutlinePrimary"
        (click)="selected(config.value)"
        [class.me-1]="!last"
    ></wdx-radio-button>
}
